import { APP_TAB } from './app';

const MESSAGE_PREFIX = 'nkf.assistant.suggestions.';

// Suggestion chips send their label as the question.
const SUGGESTION = Object.freeze({
  IDWG: { labelKey: MESSAGE_PREFIX + 'idwg' },
  DRY_WEIGHT_CHANGE: {
    labelKey: MESSAGE_PREFIX + 'dryWeightChange',
  },
  CALL_CARE_TEAM: { labelKey: MESSAGE_PREFIX + 'callCareTeam' },
  LOG_MEAL: { labelKey: MESSAGE_PREFIX + 'logMeal' },
  POTASSIUM_FOODS: {
    labelKey: MESSAGE_PREFIX + 'potassiumFoods',
  },
  WEEKLY_SUMMARY: { labelKey: MESSAGE_PREFIX + 'weeklySummary' },
  WHEN_CALL_CARE_TEAM: {
    labelKey: MESSAGE_PREFIX + 'whenCallCareTeam',
  },
  LOG_SYMPTOM: { labelKey: MESSAGE_PREFIX + 'logSymptom' },
});

export const ASSISTANT_DEFAULT_SUGGESTIONS = Object.freeze([
  SUGGESTION.LOG_MEAL,
  SUGGESTION.IDWG,
  SUGGESTION.CALL_CARE_TEAM,
]);

export const ASSISTANT_TAB_SUGGESTIONS = Object.freeze({
  [APP_TAB.FLUID]: [SUGGESTION.IDWG, SUGGESTION.DRY_WEIGHT_CHANGE, SUGGESTION.CALL_CARE_TEAM],
  [APP_TAB.DIET]: [SUGGESTION.LOG_MEAL, SUGGESTION.POTASSIUM_FOODS, SUGGESTION.WEEKLY_SUMMARY],
  [APP_TAB.SYMPTOMS]: [SUGGESTION.WHEN_CALL_CARE_TEAM, SUGGESTION.LOG_SYMPTOM],
});
